/* Skin2Glow PDP v4 behaviour. Idempotent: safe to call again after shopify:section:load. */
(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var rm = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var once = function (el, key) { if (!el || el.dataset[key]) return false; el.dataset[key] = '1'; return true; };

  /* Scrolled header state.
     The v4 draft observed a #s2g-hsent sentinel, but that element is position:absolute inside
     .s2g-pdp, which is position:static, so it anchored to the viewport instead of the document and
     reported top:0 at every scroll offset. The observer therefore never fired: html.s2g-on was
     never set, the header never painted its grey bar and the lockup never scaled to .68.
     Driving it straight off scrollY removes the dependency on any element's position, and works
     identically for wheel scrolling, window.scrollTo, keyboard and touch. */
  function initHeader() {
    var root = document.documentElement;
    if (root.dataset.s2gHeader) return;
    root.dataset.s2gHeader = '1';
    root.classList.add('s2g-pdp-page');
    var ann = $('.s2g-ann');
    // switch once the announcement bar has scrolled past, matching the mockup's sentinel at 110px
    var threshold = (ann ? ann.getBoundingClientRect().height : 32) + 8;
    var ticking = false;
    function apply() {
      ticking = false;
      root.classList.toggle('s2g-on', (window.scrollY || window.pageYOffset || 0) > threshold);
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(apply); } }
    addEventListener('scroll', onScroll, { passive: true });
    addEventListener('resize', function () {
      var a = $('.s2g-ann');
      threshold = (a ? a.getBoundingClientRect().height : 32) + 8;
      apply();
    }, { passive: true });
    apply();
  }

  function initGallery(root) {
    var gm = $('.s2g-gmain', root);
    if (!once(gm, 's2gInit')) return;
    var gs = $$('.s2g-gs', gm), th = $$('.s2g-gthumbs button', root), gp = $('.s2g-gprev', root), gn = $('.s2g-gnext', root), gc = $('.s2g-gcnt', root), gi = 0;
    if (!gs.length) return;
    function go(i, smooth) { i = Math.max(0, Math.min(gs.length - 1, i)); gm.scrollTo({ left: i * gs[0].getBoundingClientRect().width, behavior: (smooth !== false && !rm) ? 'smooth' : 'auto' }); }
    function setI(i) {
      gi = i; th.forEach(function (b, k) { b.classList.toggle('on', k === i); b.setAttribute('aria-selected', k === i); });
      if (gc) gc.textContent = ('0' + (i + 1)).slice(-2) + ' / ' + ('0' + gs.length).slice(-2);
      if (gp) gp.disabled = i === 0; if (gn) gn.disabled = i === gs.length - 1;
    }
    th.forEach(function (b, k) { b.addEventListener('click', function () { go(k); }); });
    if (gp) gp.addEventListener('click', function () { go(gi - 1); });
    if (gn) gn.addEventListener('click', function () { go(gi + 1); });
    var gio = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) setI(gs.indexOf(e.target)); }); }, { root: gm, threshold: .6 });
    gs.forEach(function (s) { gio.observe(s); });
    addEventListener('resize', function () { go(gi, false); });
    setI(0);
  }

  function initStickyAtc(root) {
    var atc = $('.s2g-buy .s2g-atc', root), satc = $('.s2g-satc', root);
    if (!atc || !once(satc, 's2gInit')) return;
    new IntersectionObserver(function (es) {
      var e = es[0];
      /* 2026-09-29 Ales (like sharkninja.de): the bar shows whenever the real Add to bag is off
         screen, BEFORE it (from the first view of the photos) as well as after it, and steps
         aside while the real button is visible. Was: only after scrolling past it. */
      satc.classList.toggle('on', !e.isIntersecting);
    }).observe(atc);
  }

  /* Headline carousel. The indigo rule under the active headline fills 0 -> 100%
     over the 4.5s slide time (CSS animation "s2gprog"); animationend advances the
     slide, so there is one clock and no drift. Hover and the pause button pause the
     CSS animation via .paused on the section (no hover pause, Ales 2026-09-08). Reduced motion: no autoplay,
     the CSS holds a static 75px segment. */
  function initStacks(scope) {
    $$('.s2g-stack', scope).forEach(function (st) {
      if (!once(st, 's2gInit')) return;
      var its = $$('.s2g-it', st), wrap = st.closest('.s2g-acar');
      if (!its.length || !wrap) return;
      var ctl = $('.s2g-ctl', wrap), cnt = ctl && $('.cnt', ctl), play = ctl && $('.play', ctl), i = 0, on = !rm, everOut = false, interacted = false;
      /* serum-v4.html (2026-09-14, notes 7 + 8): one picture per headline, cross-faded with the
         text; the before/after compare box counts as a picture. A .doc slide switches the figure
         to document style (contain on white, clinical badge). */
      var fig = $('.s2g-acar-img', wrap), imgs = fig ? $$(':scope > img, :scope > .s2g-cmp', fig) : [];
      function isDoc(el) { return el.classList.contains('doc') || el.hasAttribute('data-doc'); }
      function set(k) {
        i = (k + its.length) % its.length;
        its.forEach(function (x, n) { x.classList.toggle('on', n === i); });
        if (cnt) cnt.textContent = (i + 1) + '/' + its.length;
        if (imgs.length) {
          var im = imgs[Math.min(i, imgs.length - 1)];
          imgs.forEach(function (x) { x.classList.toggle('on', x === im); });
          fig.classList.toggle('doc', isDoc(im));
        }
      }
      function sync() {
        wrap.classList.toggle('paused', !on);
        if (play) { play.classList.toggle('paused', !on); play.setAttribute('aria-label', on ? play.dataset.pause : play.dataset.play); }
      }
      its.forEach(function (x, n) { var h = $('h3', x); if (h) h.addEventListener('click', function () { interacted = true; set(n); }); });
      if (ctl) {
        var pv = $('.prev', ctl), nx = $('.next', ctl);
        if (pv) pv.addEventListener('click', function () { interacted = true; set(i - 1); });
        if (nx) nx.addEventListener('click', function () { interacted = true; set(i + 1); });
        if (play) play.addEventListener('click', function () { interacted = true; on = !on; sync(); });
      }
      /* Review 2026-09-14 (PDRN, note 2): the timed advance is back. The .s2g-rule bar runs
         4.5s per headline (@keyframes s2gprog) and its end moves to the next one; the pause
         button, the compare-box hold and prefers-reduced-motion (animation:none) all stop it.
         Still back to slide 1 when the section leaves the viewport and comes back, never while
         the customer is mid-interaction. */
      set(0); sync();
      st.addEventListener('animationend', function (e) { if (e.animationName === 's2gprog' && on) set(i + 1); });
      new IntersectionObserver(function (es) {
        var e = es[0];
        if (!e.isIntersecting) { everOut = true; return; }
        if (everOut && !interacted) set(0);
        everOut = false;
      }, { threshold: 0 }).observe(wrap);
      /* compare slider: pointer events on the box itself (touch-action:none in the CSS) so a
         horizontal drag is not taken as a page gesture on phones; the range input stays in sync
         both ways for keyboard and desktop mouse. */
      $$('.s2g-cmp', fig || st).forEach(function (c) {
        var r = $('.s2g-cmp-r', c), b = $('.s2g-cmp-b', c), h = $('.s2g-cmp-h', c), box = $('.s2g-cmp-box', c), dragging = false;
        if (!r || !b || !h || !box) return;
        function setPct(v) { v = Math.max(0, Math.min(100, v)); r.value = v; b.style.clipPath = 'inset(0 ' + (100 - v) + '% 0 0)'; h.style.left = v + '%'; }
        function u() { setPct(r.value); }
        function pctFromX(clientX) { var rect = box.getBoundingClientRect(); return (clientX - rect.left) / rect.width * 100; }
        r.addEventListener('input', u);
        box.addEventListener('pointerdown', function (e) { dragging = true; wrap.classList.add('hold'); box.setPointerCapture(e.pointerId); setPct(pctFromX(e.clientX)); e.preventDefault(); });
        box.addEventListener('pointermove', function (e) { if (!dragging) return; setPct(pctFromX(e.clientX)); });
        function endDrag(e) { if (!dragging) return; dragging = false; wrap.classList.remove('hold'); if (box.releasePointerCapture && e.pointerId !== undefined) { try { box.releasePointerCapture(e.pointerId); } catch (err) {} } }
        box.addEventListener('pointerup', endDrag); box.addEventListener('pointercancel', endDrag);
        r.addEventListener('pointerdown', function () { wrap.classList.add('hold'); });
        ['pointerup', 'pointercancel'].forEach(function (ev) { window.addEventListener(ev, function () { wrap.classList.remove('hold'); }); });
        u();
      });
    });
  }

  /* claims strip pace, as on home-v5.html: 27.5 px/s whatever the copy length (half the track scrolls per loop) */
  var CLAIMS_PX_PER_S = 27.5;
  function initClaims(scope) {
    $$('.s2g-ctrack', scope).forEach(function (tr) {
      if (!once(tr, 's2gInit')) return;
      function setDur() {
        var half = tr.scrollWidth / 2;
        if (half > 0) tr.style.animationDuration = (half / CLAIMS_PX_PER_S) + 's';
      }
      setDur();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(setDur);
      addEventListener('resize', setDur);
    });
  }

  function initRails(scope) {
    $$('[data-s2g-rail]', scope).forEach(function (sec) {
      var r = $('.s2g-rail', sec) || $('.s2g-cards', sec), ctl = $('.s2g-ctl', sec);
      if (!r || !ctl || !once(r, 's2gInit')) return;
      var tiles = $$(':scope > *', r), cnt = $('.cnt', ctl), pv = $('.prev', ctl), nx = $('.next', ctl);
      if (!tiles.length) return;
      function step() { return tiles[0].getBoundingClientRect().width + 8; }
      function upd() {
        var k = Math.round(r.scrollLeft / step());
        if (cnt) cnt.textContent = (Math.min(k, tiles.length - 1) + 1) + ' / ' + tiles.length;
        if (pv) pv.disabled = r.scrollLeft < 4; if (nx) nx.disabled = r.scrollLeft + r.clientWidth >= r.scrollWidth - 4;
      }
      if (pv) pv.addEventListener('click', function () { r.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (nx) nx.addEventListener('click', function () { r.scrollBy({ left: step(), behavior: 'smooth' }); });
      r.addEventListener('scroll', upd, { passive: true }); upd();
    });
  }

  function initChapters(root) {
    var ch = $('.s2g-chap', root);
    if (!once(ch, 's2gInit')) return;
    var cb = $('.s2g-chap > button', ch);
    cb.addEventListener('click', function () { var o = ch.classList.toggle('open'); cb.setAttribute('aria-expanded', o); });
    $$('a', ch).forEach(function (a) { a.addEventListener('click', function () { ch.classList.remove('open'); cb.setAttribute('aria-expanded', 'false'); }); });
  }

  function initToggles(scope) {
    $$('[data-s2g-toggle]', scope).forEach(function (b) {
      if (!once(b, 's2gInit')) return;
      b.addEventListener('click', function () {
        var t = $(b.getAttribute('data-s2g-toggle')); if (!t) return;
        if (t.tagName === 'DETAILS') { t.open = true; t.scrollIntoView({ behavior: rm ? 'auto' : 'smooth', block: 'center' }); }
        else { t.hidden = !t.hidden; }
      });
    });
  }

  /* Rotating announcement: one message at a time, cross-fading every 3.2s.
     Reduced motion shows the first line only (handled in CSS). */
  function initAnnouncement(scope) {
    $$('.s2g-ann', scope).forEach(function (ann) {
      if (!once(ann, 's2gInit')) return;
      var bs = $$('b', ann), k = 0;
      if (bs.length < 2 || rm) return;
      setInterval(function () {
        bs[k].classList.remove('on');
        k = (k + 1) % bs.length;
        bs[k].classList.add('on');
      }, 3200);
    });
  }

  /* reviews rows (2026-09-14, note 10): the mockup's avatar circle shows the reviewer's initials.
     Judge.me draws its own glyph in .jdgm-rev__icon, so the initials are derived here from the
     printed name ("M. B." -> "MB") into a data attribute the CSS prints; nothing else is touched. */
  function initReviewRows(scope) {
    $$('.s2g-revs .jdgm-rev', scope).forEach(function (r) {
      if (!once(r, 's2gInit')) return;
      var ic = $('.jdgm-rev__icon', r), au = $('.jdgm-rev__author', r);
      if (!ic || !au) return;
      var ini = au.textContent.trim().split(/[\s.]+/).filter(Boolean).map(function (w) { return w.charAt(0); }).join('').slice(0, 2).toUpperCase();
      if (ini) ic.setAttribute('data-s2g-ini', ini);
    });
  }


  /* Back in stock (Ales 2026-09-19). The Notify-me button opens the inline form; submit posts
     the email + variant to Klaviyo's client Back in Stock API (public site key, no onsite JS
     needed). The optional newsletter box adds a list subscription. Messages come from the
     block's data attributes so this file stays free of Liquid. */
  function initBis(root) {
    var box = $('[data-bis]', root);
    if (!box || !once(box, 's2gInit')) return;
    var open = $('.s2g-bis-open', box), form = $('.s2g-bis-form', box), email = $('input[type="email"]', form),
        go = $('.s2g-bis-go', form), msg = $('.s2g-bis-msg', form), news = $('input[name="news"]', form);
    var company = box.dataset.company, list = box.dataset.list, variant = box.dataset.variant;
    function show(focus) {
      form.hidden = false; open.hidden = true; open.setAttribute('aria-expanded', 'true');
      if (focus) email.focus({ preventScroll: true });
    }
    function say(t, ok) { msg.textContent = t; msg.hidden = false; msg.classList.toggle('ok', !!ok); }
    function post(url, body) {
      return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': '2025-04-15' }, body: JSON.stringify(body) });
    }
    open.addEventListener('click', function () { show(true); });
    /* 2026-09-24, Ales: a sold-out CARD now carries a Notify me button that links
       here as <product-url>#notify, so the customer must land with the form
       already open and the email field ready. Without this the hash does nothing
       and they arrive at a closed form having already asked for it twice. */
    function openFromHash() {
      if (location.hash !== '#notify') return;
      show(false);
      box.scrollIntoView({ behavior: rm ? 'auto' : 'smooth', block: 'center' });
      setTimeout(function () { email.focus({ preventScroll: true }); }, rm ? 0 : 450);
    }
    openFromHash();
    window.addEventListener('hashchange', openFromHash);
    $$('[data-bis-jump]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        show(false);
        box.scrollIntoView({ behavior: rm ? 'auto' : 'smooth', block: 'center' });
        setTimeout(function () { email.focus({ preventScroll: true }); }, rm ? 0 : 450);
      });
    });
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var v = (email.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) { say(box.dataset.bad); email.focus(); return; }
      go.classList.add('btn--loading'); go.disabled = true; msg.hidden = true;
      var bis = { data: { type: 'back-in-stock-subscription', attributes: { profile: { data: { type: 'profile', attributes: { email: v } } }, channels: ['EMAIL'] },
        relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variant } } } } };
      post('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + company, bis).then(function (r) {
        if (!r.ok) throw new Error('bis ' + r.status);
        if (news && news.checked && list) {
          var sub = { data: { type: 'subscription', attributes: { profile: { data: { type: 'profile', attributes: { email: v,
            subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } }, custom_source: 'Back in stock form' },
            relationships: { list: { data: { type: 'list', id: list } } } } };
          return post('https://a.klaviyo.com/client/subscriptions/?company_id=' + company, sub).catch(function () {});
        }
      }).then(function () {
        $('.s2g-bis-row', form).hidden = true; $('.s2g-bis-l', form).hidden = true;
        $('.s2g-bis-opt', form).hidden = true; $('.s2g-bis-c', form).hidden = true;
        say(box.dataset.ok, true);
      }).catch(function () {
        say(box.dataset.err);
      }).then(function () { go.classList.remove('btn--loading'); go.disabled = false; });
    });
  }

  function initAll(scope) {
    scope = scope || document;
    if ($('.s2g-pdp')) initHeader();
    $$('.s2g-pdp', scope).forEach(function (root) { initGallery(root); initStickyAtc(root); initChapters(root); initBis(root); });
    initStacks(scope); initRails(scope); initToggles(scope); initClaims(scope); initAnnouncement(scope); initReviewRows(scope);
  }

  if (document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', function () { initAll(); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

/* ---------------------------------------------------------------------------
   v5 PDP: the tick-to-choose routine block, 2026-09-14.
   Ticking a row updates the running total, the line saying what that total
   unlocks, and the button. Untick everything and the button disables rather
   than adding nothing.
   Thresholds are the shop's real reward tiers, the same ones the cart ladder
   and the drawer use: 95 shipping, 100 tester, 200 gift.
--------------------------------------------------------------------------- */
(function () {
  var up = document.querySelector('.s2g-up');
  if (!up) return;
  var upt = up.querySelector('.s2g-upt');
  if (!upt) return;
  /* This file is loaded with `defer` by EIGHT different PDP sections, so it
     executes eight times on one page. Binding the tick handler once per run
     gave eight listeners, each toggling aria-pressed, which cancelled out on
     every even count - the ticks looked completely dead. Claim the block on
     the first run and bail on the rest. */
  if (up.dataset.s2gRoutineBound) return;
  up.dataset.s2gRoutineBound = '1';

  var rows = Array.prototype.slice.call(up.querySelectorAll('.s2g-upi'));
  var sum = upt.querySelector('[data-sum]');
  var lbl = upt.querySelector('[data-l]');
  var gift = upt.querySelector('[data-g]');
  /* PDP-SPEC #5: the button was moved out of .s2g-upt to sit under Add to
     bag, so it is no longer a descendant of .s2g-up - look it up on the
     document and unhide it once the routine rows exist. */
  /* 2026-09-14: there are now TWO of these - the buy-column one under Add to bag and
     the .s2g-com-r under the rail intro - so unhide and disable ALL of them, not just
     the first. The click handler already uses closest(), so it covered both already. */
  var btns = Array.prototype.slice.call(
    document.querySelectorAll('[data-addroutine]'));
  btns.forEach(function (b) { b.hidden = false; });
  var btnTots = Array.prototype.slice.call(
    document.querySelectorAll('[data-btn-total]'));
  var base = parseInt(upt.getAttribute('data-base'), 10) || 0;

  /* Money formatting has to follow the STOREFRONT, not a hardcoded euro string:
     the same theme serves AT/DE and HR/SI. Read the format from a price Liquid
     already rendered rather than inventing one. */
  /* 2026-09-14: the mockup shows EUR 439,00 - the trailing ,00 STAYS. The old
     replace(/,00$/,'') stripped it, so the JS-recalculated total read "439"
     while the Liquid-rendered one beside it read "439,00". */
  function money(cents) {
    return '\u20ac' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function paint() {
    var on = rows.filter(function (r) {
      var t = r.querySelector('.tick');
      return t && t.getAttribute('aria-pressed') === 'true';
    });
    rows.forEach(function (r) {
      var t = r.querySelector('.tick');
      r.classList.toggle('off', !(t && t.getAttribute('aria-pressed') === 'true'));
    });
    var add = on.reduce(function (n, r) {
      return n + (parseInt(r.getAttribute('data-price'), 10) || 0);
    }, 0);
    var total = base + add;

    if (sum) sum.textContent = money(total);
    btnTots.forEach(function (t) { t.textContent = money(total); });
    if (lbl) {
      /* singular, plural and none are three separate strings, not one template
         with a digit swapped in: "1 products" is wrong in every language here,
         and German/Croatian/Slovenian do not all pluralise the same way. */
      if (on.length === 0) {
        lbl.textContent = lbl.getAttribute('data-none') || '';
      } else if (on.length === 1) {
        lbl.textContent = lbl.getAttribute('data-one') || '';
      } else {
        lbl.textContent = (lbl.getAttribute('data-many') || '')
          .replace('N', String(on.length));
      }
    }
    if (gift) {
      var key = total >= 20000 ? 'all' : total >= 10000 ? 'ship_test'
              : total >= 9500 ? 'ship' : 'none';
      gift.textContent = gift.getAttribute('data-' + key) || '';
    }
    btns.forEach(function (b) { b.disabled = on.length === 0; });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('.tick');
    if (t) {
      t.setAttribute('aria-pressed',
        t.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
      paint();
      return;
    }
    var go = e.target.closest('[data-addroutine]');
    if (!go || go.disabled) return;
    var items = [{ id: parseInt(
      (document.querySelector('.product-variant-id') || {}).value, 10), quantity: 1 }];
    rows.forEach(function (r) {
      var tk = r.querySelector('.tick');
      if (tk && tk.getAttribute('aria-pressed') === 'true') {
        items.push({ id: parseInt(r.getAttribute('data-variant'), 10), quantity: 1 });
      }
    });
    items = items.filter(function (i) { return i.id; });
    if (!items.length) return;
    go.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items }),
      credentials: 'same-origin'
    }).then(function () {
      /* 2026-09-29: localised cart (was '/cart', which switched /hr and /de visitors to English) */
      var dr = document.querySelector('[data-drawer]');
      window.location.href = (dr && dr.getAttribute('data-cart-url')) || '/cart';
    })
      .catch(function () { go.disabled = false; });
  });

  paint();
})();

/* Routine card / rail tile bag button: swap the bag glyph for a tick once the item is
   in the cart. serum-v4.html does this with a .added class on .bagb and .tbag.

   ONE delegated listener, registered at TOP LEVEL (2026-09-14: an earlier version was
   anchored inside the .tick handler and never registered - anchor on surrounding context).

   Review 2026-09-14 (Ales, mobile, "when added change icon"): the first version waited for
   a .btn--loading class on the button, but the theme's ProductForm never sets one (verified
   in Chromium and WebKit: the click posts fetch('/cart/add.js') and nothing on the button
   changes). So the success signal is that fetch itself: the click remembers the button, the
   next /cart/add request that resolves OK flips it to the tick. A failed add (non-2xx)
   shows no tick; a click that never posts (sold out, validation) is forgotten after 8s.
   2026-09-15, Ales: "once added it should stay a swoosh and not return to the bag" - the
   tick is no longer cleared; it stays for the life of the page. */
(function () {
  if (document.documentElement.dataset.s2gBagAdded) return;
  document.documentElement.dataset.s2gBagAdded = '1';
  var pending = null, pendingT = null;
  var origFetch = window.fetch;
  if (!origFetch) return;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    if (pending && /\/cart\/add(\.js)?(\?|$)/.test(url)) {
      var btn = pending; pending = null; clearTimeout(pendingT);
      p.then(function (res) {
        if (!res || !res.ok) return;
        btn.classList.add('added'); btn.setAttribute('aria-pressed', 'true');
      }).catch(function () {});
    }
    return p;
  };
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.s2g-bagb, .s2g-tbag');
    if (!btn || btn.disabled) return;
    pending = btn; clearTimeout(pendingT);
    pendingT = setTimeout(function () { pending = null; }, 8000);
  });
})();

/* Rail chips: the same height on every tile. 2026-09-15, Ales: "adjust the height of the
   white windows to the same height with every product". The chip is absolute inside its
   tile, so CSS cannot equalise siblings; measure the tallest chip per rail and write it to
   --s2g-chip-h (read by .s2g-tchip min-height). Measured now, again once fonts are in, and
   on resize (the notes re-wrap at every width). */
(function () {
  var rails = document.querySelectorAll('.s2g-rail');
  if (!rails.length) return;
  function level() {
    rails.forEach(function (rail) {
      rail.style.removeProperty('--s2g-chip-h');
      var h = 0;
      rail.querySelectorAll('.s2g-tchip').forEach(function (c) {
        h = Math.max(h, c.getBoundingClientRect().height);
      });
      if (h) rail.style.setProperty('--s2g-chip-h', Math.ceil(h) + 'px');
    });
  }
  level();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(level);
  var t;
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(level, 120); });
})();

/* 2026-09-28, Ales: "the ladder would be live". The offer ladder under Natasa's quote was
   drawn once by Liquid and never moved, so adding to the bag, the free-gift app, the
   drawer steppers or the protection switch left it showing the old cart. After any
   successful cart write it is re-rendered by Shopify (section s2g-pdp-ladder, same
   snippet as the page), so wording, money format and the protection rule stay in Liquid. */
(function () {
  /* s2g-pdp.js is included by NINE PDP sections, so this file runs nine times per page.
     Without this claim the fetch/XHR hooks stacked nine deep and one cart change fired
     nine identical ladder requests at once (measured 2026-09-28). Run once. */
  if (window.__s2gLiveLadder) return;
  window.__s2gLiveLadder = true;
  if (!document.querySelector('[data-s2g-lad]')) return;
  var timer = null;
  var CART = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  function refresh() {
    var url = location.pathname + (location.search ? location.search + '&' : '?') + 'sections=s2g-pdp-ladder';
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j || !j['s2g-pdp-ladder']) return;
        var box = document.createElement('div');
        box.innerHTML = j['s2g-pdp-ladder'];
        var next = box.querySelector('[data-s2g-lad]');
        var cur = document.querySelector('[data-s2g-lad]');
        if (next && cur) cur.parentNode.replaceChild(next, cur);
      })
      .catch(function () {});
  }
  function soon() { clearTimeout(timer); timer = setTimeout(refresh, 350); }
  var origFetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    if (CART.test(url)) p.then(function (r) { if (r && r.ok) soon(); }).catch(function () {});
    return p;
  };
  /* apps that still use XMLHttpRequest (the free-gift app adds its reward this way) */
  var open = XMLHttpRequest.prototype.open, send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this.__s2gCart = CART.test(String(u || '')); return open.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    if (this.__s2gCart) this.addEventListener('load', function () { if (this.status >= 200 && this.status < 300) soon(); });
    return send.apply(this, arguments);
  };
  /* back from another page or tab: the cart may have changed there */
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') refresh(); });
})();

/* 2026-09-29 Ales: Read more under the description on phones. This file runs once per PDP
   section that includes it (nine), so it claims itself once. */
(function () {
  if (window.__s2gReadMore) return;
  window.__s2gReadMore = true;
  var phone = window.matchMedia('(max-width:899px)');
  function check() {
    document.querySelectorAll('[data-s2g-desc]').forEach(function (w) {
      var d = w.querySelector('.s2g-desc');
      if (!d) return;
      var line = parseFloat(getComputedStyle(d).lineHeight) || 22;
      w.classList.toggle('can', phone.matches && d.scrollHeight > line * 4 + 8);
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.s2g-desc-more');
    if (!b) return;
    var w = b.closest('[data-s2g-desc]');
    var open = !w.classList.contains('open');
    w.classList.toggle('open', open);
    b.setAttribute('aria-expanded', open ? 'true' : 'false');
    b.textContent = open ? b.getAttribute('data-less') : b.getAttribute('data-more');
    if (!open) w.scrollIntoView({ block: 'nearest' });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check); else check();
  window.addEventListener('load', check);
  if (phone.addEventListener) phone.addEventListener('change', check);
})();

/* 2026-09-29 Ales: instant feedback on Add to bag. The add + drawer render take ~0.8s on wifi and
   2-3s on mobile data with no sign the tap landed. The button goes busy at once (dark, spinner,
   no double adds) and clears when the bag opens, when the theme shows an add error, or after 8s.
   Runs once per page (this file is included by nine sections). */
(function () {
  if (window.__s2gBusy) return;
  window.__s2gBusy = true;
  var busy = [];
  function clear() { busy.forEach(function (b) { b.classList.remove('s2g-busy'); b.removeAttribute('aria-busy'); }); busy = []; }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.s2g-atc');
    if (!b || b.type !== 'submit' || b.disabled || b.closest('.s2g-bis-form')) return;
    if (b.classList.contains('s2g-busy')) { e.preventDefault(); return; }
    b.classList.add('s2g-busy'); b.setAttribute('aria-busy', 'true'); busy.push(b);
    setTimeout(clear, 8000);
  });
  new MutationObserver(function () {
    if (!busy.length) return;
    var d = document.querySelector('.s2g-drawer.drawer.open, .s2g-drawer .drawer.open');
    var err = document.querySelector('.s2g-pdp .product-form__error-message:not([hidden])');
    /* 2026-09-29: the bag now opens at once with an 'adding' row (.s2g-opt); stay busy (no double
       adds) until that row is gone, i.e. until Shopify has answered */
    var pending = document.querySelector('.s2g-drawer .s2g-opt');
    if ((d && !pending) || (err && err.textContent.trim())) clear();
  }).observe(document.body, { subtree: true, attributes: true, attributeFilter: ['class', 'hidden'] });
})();
